import type { Stats } from '../../domain/stats.js';

function formatChars(n: number): string {
  if (n < 1000) return String(n);
  if (n < 10000) return (n / 1000).toFixed(1) + 'k';
  return Math.floor(n / 1000) + 'k';
}

export function renderStatCards(root: HTMLElement, stats: Stats) {
  root.innerHTML = `
    <div class="stat-cards">
      <div class="stat-card">
        <div class="stat-card__icon" aria-hidden="true">🔥</div>
        <div class="stat-card__value">${stats.streak}</div>
        <div class="stat-card__label">連続日数</div>
      </div>
      <div class="stat-card">
        <div class="stat-card__icon" aria-hidden="true">📅</div>
        <div class="stat-card__value">${stats.totalDays}</div>
        <div class="stat-card__label">累計日数</div>
      </div>
      <div class="stat-card">
        <div class="stat-card__icon" aria-hidden="true">✍️</div>
        <div class="stat-card__value">${formatChars(stats.totalChars)}</div>
        <div class="stat-card__label">累計文字数</div>
      </div>
    </div>
  `;
}
